'use strict';

import './employeeCarousel.scss';
import template from './employeeCarousel.template.html';
import controller from './employeeCarousel.controller.js';

const component = {
    bindings: {
        location: '@',
        isInModal: '@',
        showSpcAlternate: '<',
        halfFace: '<',
        showViewAll: '<'
    },
    controller,
    template
};

export default component;